import { createSlice } from "@reduxjs/toolkit";

const defaultValue = {
 tab: "transaction",
};

export const dialogTransactionTabSlice = createSlice({
 name: "dialogTransactionTab",
 initialState: defaultValue,
 reducers: {
  setTab: (state, action) => {
   state.tab = action.payload;
  },
  resetTab: (state, _) => {
   state.tab = "transaction";
  },
 },
});

export const { setTab, resetTab } = dialogTransactionTabSlice.actions;
export default dialogTransactionTabSlice.reducer;
